/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* Licensed under the MIT License. See LICENSE.md in the project root for license terms.
*--------------------------------------------------------------------------------------------*/

import { editor } from "monaco-editor/esm/vs/editor/editor.api";
import { FilePath } from "../../types";
import { getFileName } from "../../utils/utils";
import { ExpandableBlock, Text } from "@itwin/itwinui-react";
import { FileIcon } from "../file-icon/FileIcon";
import styles from "./DiagnosticList.module.css";
import { DiagnosticListItem } from "./DiagnosticListItem";
import { ErrorCountBadge } from "./ErrorCountBadge";
import "@vscode/codicons/dist/codicon.css";

export interface DiagnosticListProps {
  markers: editor.IMarker[];
  markerSelected?: editor.IMarker;
  file: string;
  onClick: (marker: editor.IMarker) => void;
}

export const DiagnosticList = ({ markers, markerSelected, file, onClick }: DiagnosticListProps) => {

  return (
    <ExpandableBlock key={file} title={<Title filePath={file} errorCount={markers.length} />} styleType="borderless" size="small" className={styles.expandableBlock} isExpanded={true}>
      {markers.map((marker, index) => (
        <DiagnosticListItem
          key={`diagnosticListItem-${index}`}
          marker={marker}
          isSelected={markerSelected === marker}
          onClick={() => onClick(marker)}
        />
      ))}
    </ExpandableBlock>
  );
}

const Title = ({ filePath, errorCount }: { filePath: FilePath, errorCount: number }) => {
  return (
    <div className={styles.title}>
      <FileIcon filePath={filePath} />
      <Text>{getFileName(filePath)}</Text>
      <Text isMuted>{filePath.replace("file://", "")}</Text>
      <ErrorCountBadge errorCount={errorCount} />
    </div >
  )
};
